"use client"

import { useState } from "react"
import "./css/transico.css"
import img1 from "../img/caru/1.png"
import img2 from "../img/caru/2.png"
import img3 from "../img/caru/3.png"
import img4 from "../img/caru/4.png"
import img5 from "../img/caru/5.png"
import { useMobile } from "../hooks/use-mobile" // Corregida la importación con alias
import MobileCollapsibleService from "./MobileCollapsibleService"

const TransporteIconos = () => {
  const [activeTab, setActiveTab] = useState(0)
  const isMobile = useMobile()

  const services = [
    {
      id: 0,
      title: "ELABORACIÓN DE DUCAS",
      icon: "📄",
      description: "¿Qué es el DUCA?",
      content: (
        <div className="duca-content">
          <p className="duca-intro">
            El DUCA sustituye y unifica varios documentos aduaneros y se divide en tres tipos:
          </p>
          <div className="duca-types">
            <div className="duca-type">
              <h4>
                <strong>DUCA-F (Formulario):</strong>
              </h4>
              <p>Para comercio entre empresas dentro de Centroamérica.</p>
            </div>
            <div className="duca-type">
              <h4>
                <strong>DUCA-D (Declaración):</strong>
              </h4>
              <p>Para importaciones y exportaciones con países fuera de la región.</p>
            </div>
            <div className="duca-type">
              <h4>
                <strong>DUCA-T (Tránsito):</strong>
              </h4>
              <p>Para mercancías que pasan por varios países centroamericanos sin cambiar de dueño.</p>
            </div>
          </div>
        </div>
      ),
      image: img1,
      imageClass: "",
    },
    {
      id: 1,
      title: "GESTIÓN ADUANERA",
      icon: "🛡️",
      description: "¿Por qué es importante?",
      content: (
        <div className="gestion-content">
          <p className="gestion-intro">Una buena gestión aduanera:</p>
          <div className="gestion-benefits">
            <div className="gestion-benefit">
              <span className="benefit-bullet">•</span>
              <p>Evita sanciones y retrasos.</p>
            </div>
            <div className="gestion-benefit">
              <span className="benefit-bullet">•</span>
              <p>Optimiza costos.</p>
            </div>
            <div className="gestion-benefit">
              <span className="benefit-bullet">•</span>
              <p>Asegura el cumplimiento legal.</p>
            </div>
            <div className="gestion-benefit">
              <span className="benefit-bullet">•</span>
              <p>Facilita el comercio internacional.</p>
            </div>
          </div>

          <h4 className="gestion-subtitle">¿Quién realiza la gestión aduanera?</h4>
          <div className="gestion-who">
            <div className="gestion-agent-title">
              <p>
                <strong>Agentes aduanales o gestores aduaneros:</strong>
              </p>
              <p>Profesionales autorizados para representar legalmente a importadores/exportadores ante la aduana.</p>
            </div>
            <div className="gestion-who-item">
              <span className="who-bullet">•</span>
              <p>Departamentos de comercio exterior de empresas.</p>
            </div>
            <div className="gestion-who-item">
              <span className="who-bullet">•</span>
              <p>Consultoras aduanales o despachos especializados.</p>
            </div>
          </div>
        </div>
      ),
      image: img2,
      imageClass: "image-move-down",
    },
    {
      id: 2,
      title: "TRANSPORTE",
      icon: "🚛",
      description: "¿Cuándo se usa el transporte aduanero?",
      content: (
        <div className="transporte-content">
          <div className="transporte-when">
            <div className="transporte-when-item">
              <span className="when-bullet">•</span>
              <p>
                Cuando una mercancía entra a un país pero debe ser trasladada a otra aduana interna para su
                nacionalización.
              </p>
            </div>
            <div className="transporte-when-item">
              <span className="when-bullet">•</span>
              <p>
                Para mercancías en tránsito internacional, es decir, que cruzan un país solo como ruta hacia otro
                destino.
              </p>
            </div>
            <div className="transporte-when-item">
              <span className="when-bullet">•</span>
              <p>
                En operaciones de zonas francas, depósitos aduaneros o recintos fiscales, donde la mercancía aún no se
                ha nacionalizado.
              </p>
            </div>
          </div>

          <h4 className="transporte-subtitle">Ventajas del transporte aduanero</h4>
          <div className="transporte-advantages">
            <div className="transporte-advantage-item">
              <span className="advantage-bullet">•</span>
              <p>Mejora la logística y descongestiona puntos de entrada.</p>
            </div>
            <div className="transporte-advantage-item">
              <span className="advantage-bullet">•</span>
              <p>Permite integrar cadenas logísticas internacionales.</p>
            </div>
          </div>
        </div>
      ),
      image: img3,
      imageClass: "image-smaller",
    },
    {
      id: 3,
      title: "RECOLECCIÓN DE DOCUMENTOS",
      icon: "📁",
      description: "Beneficios de delegar la recolección de documentos al agente aduanero:",
      content: (
        <div className="recoleccion-content">
          <div className="recoleccion-benefits">
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Ahorro de tiempo para la empresa</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Mayor control y seguimiento documental</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Conocimiento del circuito logístico</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Menor riesgo de errores o pérdidas</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Cumplimiento legal y normativo</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Coordinación eficiente entre actores logísticos</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Manejo rápido de imprevistos</p>
            </div>
            <div className="recoleccion-benefit-item">
              <span className="recoleccion-bullet">•</span>
              <p>Optimización del proceso de despacho aduanal</p>
            </div>
          </div>
        </div>
      ),
      image: img4,
      imageClass: "image-move-down",
    },
    {
      id: 4,
      title: "LICENCIAS DE IMPORTACIÓN",
      icon: "✅",
      description: "¿Qué implica?",
      content: (
        <div className="licencias-content">
          <div className="licencias-todo">
            <div className="licencias-seccion">
              <div className="licencias-implica-item">
                <span className="licencias-bullet">•</span>
                <p>Identificar si el producto necesita licencia (no todos la requieren).</p>
              </div>
              <div className="licencias-implica-item">
                <span className="licencias-bullet">•</span>
                <p>Preparar la documentación: factura, ficha técnica, permisos sanitarios, etc.</p>
              </div>
              <div className="licencias-implica-item">
                <span className="licencias-bullet">•</span>
                <p>
                  Presentar la solicitud ante el ministerio o entidad correspondiente (como el Ministerio de agricultura
                  y ganadería).
                </p>
              </div>
              <div className="licencias-implica-item">
                <span className="licencias-bullet">•</span>
                <p>Dar seguimiento al trámite hasta obtener la aprobación.</p>
              </div>
            </div>

            <h4 className="licencias-subtitle">¿Para qué productos suele ser necesaria?</h4>
            <div className="licencias-seccion">
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Medicamentos o insumos médicos.</p>
              </div>
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Productos químicos o peligrosos.</p>
              </div>
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Alimentos, bebidas, suplementos.</p>
              </div>
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Equipos electrónicos con radiofrecuencia.</p>
              </div>
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Armas, productos militares o de seguridad.</p>
              </div>
              <div className="licencias-producto-item">
                <span className="licencias-bullet">•</span>
                <p>Material vegetal o animal.</p>
              </div>
            </div>

            <h4 className="licencias-subtitle">¿Por qué es importante?</h4>
            <div className="licencias-seccion">
              <p className="licencias-intro-importante">Sin la licencia de importación:</p>
              <div className="licencias-importante-item">
                <span className="licencias-bullet">•</span>
                <p>No podrás nacionalizar la mercancía en aduana.</p>
              </div>
              <div className="licencias-importante-item">
                <span className="licencias-bullet">•</span>
                <p>Puedes recibir multas o incautaciones.</p>
              </div>
              <div className="licencias-importante-item">
                <span className="licencias-bullet">•</span>
                <p>El embarque puede quedar retenido o rechazado.</p>
              </div>
            </div>
          </div>
        </div>
      ),
      image: img5,
      imageClass: "",
    },
  ]

  const currentService = services[activeTab]

  const handleTabHover = (index) => {
    if (index !== activeTab) {
      setActiveTab(index)
    }
  }

  if (isMobile) {
    return (
      <section className="transico-section mobile-layout" id="Transico">
        <div className="transico-container mobile-container">
          {services.map((service) => (
            <MobileCollapsibleService key={service.id} service={service} />
          ))}
        </div>
      </section>
    )
  }

  return (
    <section className="transico-section" id="Transico">
      <div className="transico-container">
        {/* Main Content Area */}
        <div className="main-content">
          {/* Left Content */}
          <div className="left-content" key={`left-${activeTab}`}>
            <h1 className="main-title">{currentService.description}</h1>
            <div className="main-description">
              {typeof currentService.content === "string" ? <p>{currentService.content}</p> : currentService.content}
            </div>
          </div>

          {/* Right Content - Image or visual */}
          <div className="right-content" key={`right-${activeTab}`}>
            <div className="content-visual">
              {currentService.image ? (
                <div className={`service-image-container ${currentService.imageClass}`}>
                  <img
                    src={currentService.image || "/placeholder.svg"}
                    alt={currentService.title}
                    className="service-image"
                  />
                </div>
              ) : (
                <div className="service-display">
                  <div className="service-icon-large">{currentService.icon}</div>
                  <h3 className="service-name">{currentService.title}</h3>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Bottom Navigation Tabs */}
        <div className="bottom-navigation">
          <div className="tabs-wrapper">
            {/* Triangle Indicator */}
            <div
              className="triangle-indicator"
              style={{
                left: `calc(${activeTab * (100 / services.length) + 100 / services.length / 2}% - 30px)`,
              }}
            ></div>

            <div className="tabs-container">
              {services.map((service, index) => (
                <button
                  key={service.id}
                  onMouseEnter={() => handleTabHover(index)}
                  className={`tab-item ${activeTab === index ? "active" : ""}`}
                >
                  <div className="tab-icon">{service.icon}</div>
                  <div className="tab-label">{service.title}</div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TransporteIconos
